import React from "react";

const OverviewSection = () => {
    return (
        <section className='overflow-hidden bg-[#F1F1F1]'>
            <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] md:px-[40px] px-[20px] lg:py-[88px] py-[40px] relative">
                <div className="flex flex-col lg:flex-row relative w-full items-center justify-between">
                    <div className="w-full lg:max-w-[671px] z-0 flex justify-center lg:justify-start">
                        <img
                            src="/assets/glodesk/img1.png"
                            alt="who-we-are"
                            className="w-full h-auto max-h-[300px] sm:max-h-[400px] lg:max-h-none object-cover rounded-sm"
                        />
                    </div>
                    <div className="
                relative           
                lg:absolute        
                lg:right-0 
                lg:top-[50%] lg:-translate-y-[50%] 
                -mt-[40px] sm:-mt-[60px] lg:mt-0 
                z-10 
                max-w-[90%] sm:max-w-[85%] lg:max-w-[789px] 
                w-full
                lg:p-[40px] p-[20px] sm:p-[30px] 
                bg-[#FFFFFF] border border-[#01386A45] rounded-sm shadow-sm
            ">
                        <h6 className="font-[600] font-sora lg:text-[30px] text-[20px] lg:leading-[40px] leading-[30px] lg:pb-[40px] pb-[16px] text-[#01386A]">
                            Product Overview
                        </h6>
                        <p className="font-[500] font-graphik text-[14px] md:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[28px] text-[#49577A]">
                            Glodesk is built to make managing workspaces feel simple and stress-free. It brings everything you need into one place: facility operations, CRM, bookings, billing, procurement, and more so you don’t have to juggle multiple tools.
                            <br />
                            <br />
                            Whether you run a single coworking space or manage several locations, Glodesk helps you stay organized, save time, and focus on your members instead of manual work. It’s designed to improve everyday efficiency and create a smoother, more connected experience for both operators and teams.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OverviewSection;